import { render } from "./PR23-03312023.vue?vue&type=template&id=66636e06"
import script from "./PR23-03312023.vue?vue&type=script&lang=js"
export * from "./PR23-03312023.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__